import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Avatar": Avatar, "@mui/material/Box": Box, "@mui/material/Paper": Paper, "@mui/material/Stack": Stack, "@mui/material/styles": { styled }, "@mui/material/Typography": Typography } } });
export default ClientProvider;
